import { CurrencyModel, DepartmentLandingModel, DepartmentModel, Regions } from '@/interface';
import {
    SET_DEPARTMENT,
    SET_ACTIVE_DEPARTMENT_ID,
    SET_ACTIVE_CURRENCY_ID,
    SET_ACTIVE_REGION,
    SET_NEW_CURRENCY,
    RESET_NEW_CURRENCY,
    SET_ACTIVE_KASSA_ID,
    SET_ACTIVE_DEPARTMENT_LANDING_ADDRESS,
    SET_DEPARTMENT_LANDING,
    RESET_DEPARTMENT,
    DepartmentAction,
} from './departmentActions';

export interface DepartmentReducer {
    allDepartments: DepartmentModel[];
    initialDepartments: DepartmentModel[];
    initialOpenDepartments: DepartmentModel[];
    departmentList: DepartmentModel[];
    /** Отделения-каналы с курсами мобилки и ecash.kz — вне общих списков */
    channelDepartments: DepartmentModel[];
    departmentListLanding: DepartmentLandingModel[];
    activeDepartmentId: number;
    activeDepartmentLandingAddress: string;
    activeCurrencyId: number;
    activeRegion: Regions | "";
    newCurrency: CurrencyModel;
    activeKassaId: number;
}

const initialState: DepartmentReducer = {
    departmentList: [],
    channelDepartments: [],
    allDepartments: [],
    initialDepartments: [],
    initialOpenDepartments: [],
    departmentListLanding: [],
    activeDepartmentId: 0,
    activeDepartmentLandingAddress: "",
    activeCurrencyId: 0,
    activeRegion: '',
    newCurrency: {
        code: "",
        description: "",
        country: "",
        spread: 0,
        margin: 0,
        isActive: true,
        fromParse: false,
        parseBuy: "",
        parseSale: "",
        parseSite: "",
        step: "",
        minLimit: 0,
        maxLimit: 0,
        rates: [
            {
                buy: 0,
                sale: 0,
                limitFrom: 0,
                limitTo: 0,
            },
            {
                buy: 0,
                sale: 0,
                limitFrom: 0,
                limitTo: 0,
            },
        ],
        kursKz: { buy: 0, sell: 0 }
    },
    activeKassaId: 0,
};

export const departmentReducer = (state = initialState, action: DepartmentAction): DepartmentReducer => {
    switch (action.type) {
        case RESET_DEPARTMENT:
            return { ...initialState };
        case SET_DEPARTMENT:
            return {
                ...state,
                departmentList: action.payload.departmentList,
                channelDepartments: action.payload.channelDepartments,
                allDepartments: action.payload.allDepartments,
                initialDepartments: state.initialDepartments.length
                    ? state.initialDepartments
                    : action.payload.allDepartments,
                initialOpenDepartments: state.initialOpenDepartments.length
                    ? state.initialOpenDepartments
                    : action.payload.departmentList,
            };
        case SET_DEPARTMENT_LANDING:
            return {
                ...state,
                departmentListLanding: action.payload.departmentList
            };
        case SET_ACTIVE_DEPARTMENT_ID:
            return {
                ...state,
                activeDepartmentId: action.payload.departmentId,
            };
        case SET_ACTIVE_DEPARTMENT_LANDING_ADDRESS:
            return {
                ...state,
                activeDepartmentLandingAddress: action.payload.departmentAddress,
            };
        case SET_ACTIVE_CURRENCY_ID:
            return {
                ...state,
                activeDepartmentId: action.payload.departmentId,
                activeCurrencyId: action.payload.currencyId
            };
        case SET_ACTIVE_REGION:
            return {
                ...state,
                activeRegion: action.payload.region
            };
        case SET_NEW_CURRENCY:
            return {
                ...state,
                newCurrency: action.payload.newCurrency
            };
        case RESET_NEW_CURRENCY:
            return {
                ...state,
                newCurrency: initialState.newCurrency
            };
        case SET_ACTIVE_KASSA_ID:
            return {
                ...state,
                activeKassaId: action.payload.kassaId,
            };
        default: {
            return state;
        }
    }
};